import { render, staticRenderFns } from "./DeliveriesSubmissionList.vue?vue&type=template&id=47cc8728&scoped=true&"
import script from "./DeliveriesSubmissionList.vue?vue&type=script&lang=js&"
export * from "./DeliveriesSubmissionList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveriesSubmissionList.vue?vue&type=style&index=0&id=47cc8728&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc8728",
  null
  
)

export default component.exports